import React from 'react';
import { SideBarModal } from '@/components/Modal';
import { Button } from '@/components';

interface PotentialLossConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const PotentialLossConfirmModal: React.FC<PotentialLossConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  return (
    <SideBarModal
      isOpen={isOpen}
      onClose={onClose}
      position="center"
      width="md"
      maxHeight="auto"
      showCloseButton={false}
      header={
        <div className="flex items-start gap-4">
          <div className="flex h-[40px] w-[50px] items-center justify-center rounded-lg bg-orange-50 text-orange-500">
            <i className="ri-alert-fill text-[16px]" />
          </div>
          <div>
            <div className="text-xl font-semibold text-gray-900">
              Mark as Potensi Kehilangan?
            </div>
            <div className="mt-1 text-sm text-gray-500">
              This will update the case status to Potensi Kehilangan. Do you
              want to proceed?
            </div>
          </div>
        </div>
      }
      footer={
        <div className="flex w-full justify-end gap-2">
          <Button
            onClick={onClose}
            className="rounded-xl border border-gray-200 bg-white px-6 py-2 text-gray-600 hover:bg-gray-50"
            variant={'secondary'}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isSubmitting}
            className="rounded-xl bg-red-500 px-6 py-2 text-white hover:bg-red-600"
            variant={'danger'}
          >
            {isSubmitting ? 'Saving...' : 'Mark as Potensi Kehilangan'}
          </Button>
        </div>
      }
    >
      <div className="h-0" />
    </SideBarModal>
  );
};

export default PotentialLossConfirmModal;
